module.exports = __webpack_public_path__ + "img/intensity-indicator-beginner.b1e03eac.svg";